import { queryOptions } from '@tanstack/react-query';
import culpritInformationDataGenerator from '@/modules/FileDetail/data/culpritInformation/culpritInformationDataGenerator.tsx';
import { culpritInformationQueryFunction } from '@/modules/FileDetail/queries/culpritInformation/culpritInformationQueryFunction.ts';

export const culpritInformationQueryOptions = (id: string) =>
  queryOptions({
    queryKey: ['culprit_information', id],
    queryFn: () => culpritInformationQueryFunction(id),
    enabled: !!id,
    select(data) {
      return {
        ...data,
        detailCardItems: culpritInformationDataGenerator(data),
      };
    },
  });
